import angular from "angular";

export default angular.module("dcuiCheckbox",[])
  .component("dcuiCheckbox",{
    template : `
        <label class="checkbox-container">
            <input type="checkbox" name="{{$ctrl.label}}"
                   ng-model="$ctrl.selected" 
                   ng-change="$ctrl.handleChange();">
                <span class="checkbox-surrogate">
                  <i ng-class="{'icon-checked': $ctrl.selected, 'icon-checked-gray': $ctrl.indeterminate}"></i>
                </span>                
            {{$ctrl.label}}
        </label>
        <!--<small><pre>indeterminate: {{$ctrl.indeterminate}}, selected: {{$ctrl.selected}}</pre></small>-->
    `,
    bindings : {
      name :"<?",
      label : "<?",
      tooltipLabel : "<?",
      tooltipPlacement : "<?",
      selected : "=?",
      indeterminate : "=?",
      onChange : "&?",
      onInit : "&?"
    },
    controller : ["$scope","$element",function($scope,$element){

      this.handleChange = () =>{
        if(this.onChange){
          this.onChange({selected : this.selected, indeterminate : this.indeterminate});
        }
      };

      this.$onInit =() =>{
        if(this.onInit){
          this.onInit({ctrl : this});
        }
      };

      $scope.$watch(() => this.indeterminate,(newValue,oldValue) =>{
        $element.find('input').prop('indeterminate', newValue);
      });

    }]
  }).name;



// WEBPACK FOOTER //
// ./src/ui/modules/dcui/dcui-checkbox/dcui-checkbox.component.js